<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisibel"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div style="margin-bottom: 10px">
        单位名称
      </div>
      <el-input
        v-model="unitName"
        placeholder="请输入"
      />
      <div style="margin: 10px 0">
        <span>添加单位管理教师</span>
        <el-button
          type="text"
          @click="addItem"
        >新增</el-button>
      </div>
      <div
        v-for="(item, index) in teacherArr"
        :key="index"
        style="margin-bottom: 5px"
      >
        <el-input
          v-model="item.sn"
          style="width: 60%"
          :disabled="item.name !== ''"
          @blur="seachUser(index)"
        />
        <el-input
          v-model="item.name"
          style="width: 33%"
          :disabled="true"
        />
        <el-button
          type="text"
          style="color: red"
          @click="delItem(index)"
        >删除</el-button>
      </div>
      <div style="margin: 10px 0">
        单位介绍(200字以内):
      </div>
      <el-input
        v-model="unitIntroduce"
        :autosize="{ minRows: 3}"
        type="textarea"
        placeholder="请输入"
        maxlength="200"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancel">取 消</el-button>
        <el-button
          type="primary"
          @click="comfirmThis"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { commonService } from '@/api/index'
import { mustBeNum } from '@/tool/utils'

export default {
  name: 'AddManagerDialog',
  props: {
    diaType: String,
    teachersList: Array,
    dialogName: {
      type: String,
      default: '',
    },
    dialogRemark: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisibel: false,
      title: null,
      teacherArr: [],
      unitName: '', // 单位名称
      unitIntroduce: '', // 单位介绍
    }
  },
  watch: {
    dialogName(newVal) {
      this.unitName = newVal
    },
    dialogRemark(newVal) {
      this.unitIntroduce = newVal
    },
    diaType(newVal) {
      if (newVal === 'add') {
        this.title = '添加用工单位'
      } else {
        this.title = '编辑用工单位'
      }
    },
    teachersList: {
      handler(newVal) {
        this.teacherArr = newVal
      },
      deep: true,
    },
  },
  methods: {
    delItem(index) {
      this.teacherArr.splice(index, 1)
    },
    addItem() {
      const params = {
        sn: '',
        name: '',
      }
      this.teacherArr.push(params)
    },
    // 失焦事件触发查找用户
    // eslint-disable-next-line consistent-return
    seachUser(index) {
      if (!mustBeNum(this.teacherArr[index].sn)) {
        this.teacherArr[index].name = ''
        this.$message.warning('请输入有效工号')
        return false
      }
      let flag = false
      // eslint-disable-next-line array-callback-return,consistent-return
      this.teacherArr.some((x, zIndex) => {
        if (x.sn === this.teacherArr[index].sn && zIndex !== index) {
          this.$message.warning('请勿重复添加')
          flag = true
          return true
        }
      })
      if (flag) {
        this.teacherArr[index].sn = ''
        return false
      }
      commonService()._checkTeacher(this.teacherArr[index].sn).then(res => {
        if (res.status) {
          if (res.data.isTeacher) {
            this.teacherArr[index].name = res.data.name
            this.teacherArr[index].userType = 0
          } else {
            this.$message.warning('该用户不是教师')
            this.teacherArr[index].name = ''
          }
        } else {
          this.teacherArr[index].name = ''
        }
      })
    },
    // eslint-disable-next-line consistent-return
    comfirmThis() {
      if (this.teacherArr.length === 0) {
        this.$message.warning('请设置单位管理教师')
        return false
      }
      if (this.unitName === '') {
        this.$message.warning('请设置单位名称')
        return false
      }
      if (this.unitIntroduce === '') {
        this.$message.warning('请填写单位介绍')
        return false
      }
      let flag = false
      // eslint-disable-next-line array-callback-return,consistent-return
      this.teacherArr.some(x => {
        if (x.name === '' || x.name === null) {
          this.$message.warning('请输入正确工号')
          flag = true
          return true
        }
      })
      if (flag) { return false }
      const params = {
        unitDto: {
          name: this.unitName,
          remark: this.unitIntroduce,
        },
        unitUsers: [],
      }
      this.teacherArr.forEach(x => {
        const theP = {
          userName: x.sn,
          userType: x.userType,
          realName: x.name,
        }
        params.unitUsers.push(theP)
      })
      this.$emit('addUnitConfirm', params)
    },
    cancel() {
      this.$emit('addUnitCancel')
    },
  },
}
</script>

<style scoped>
</style>
